import { useSessionStore } from "../Stores/Session";

export type ContentItem =
  | { type: "text"; text: string }
  | { type: "image"; image: string; alt?: string }
  | {
      type: "button";
      label: string;
      style?: "primary" | "secondary" | "danger";
      action: ButtonAction;
    }
  | { type: "html"; html: string }
  | { type: "key-value"; items: { key: string; value: string }[] }
  | { type: "divider" };

export type ButtonAction =
  | { type: "open-url"; url: string; newTab?: boolean }
  | { type: "open-view"; viewName: string; payload?: any }
  | { type: "custom-action"; actionName: string; actionData?: any }
  | {
      type: "http-request";
      method?: string;
      url: string;
      headers?: Record<string, string>;
      body?: any;
      successMessage?: string;
      errorMessage?: string;
    };

export interface Widget {
  id: string;
  title?: string;
  content?: ContentItem[];
  html?: string;
}

export interface SingleContentResponse {
  content?: ContentItem[];
  html?: string;
}

const post = async (body: any): Promise<any> => {
  const sessionStore = useSessionStore.getState();
  const apiUrl = sessionStore.apiUrl;
  const sdkKey = sessionStore.sdkKey;
  const session = sessionStore.session;

  if (!apiUrl || !sdkKey || !session?.gleapId) {
    throw new Error("session not ready");
  }

  const res = await fetch(`${apiUrl}/config/${sdkKey}/custom-widgets/render`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Api-Token": sdkKey,
      "Gleap-Id": session.gleapId,
      "Gleap-Hash": session.gleapHash ?? "",
    },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    throw new Error(`custom widgets proxy returned ${res.status}`);
  }
  return res.json();
};

export const fetchWidgets = async (): Promise<Widget[]> => {
  const result = await post({ kind: "widgets" });
  return Array.isArray(result?.widgets) ? result.widgets : [];
};

export const fetchView = async (
  viewName: string,
  payload: any,
): Promise<SingleContentResponse> => {
  const result = await post({ kind: "view", viewName, payload });
  if (typeof result?.html === "string") return { html: result.html };
  return { content: Array.isArray(result?.content) ? result.content : [] };
};
